<template>
    <div>
        <div class=" mb-5">
            <!-- shape Hero -->
            <section class="section-shaped my-0 pb-lg-5">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex pb-3">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3 ">My Addresses
                                </h1>
                                <p></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container shape-container d-flex  border rounded">
                    <div class="col px-0">
                        <div v-if="successMessage != null">
                            <base-alert type="primary" dismissible>
                                <span class="alert-inner--text"> {{successMessage}}</span>
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </base-alert>
                        </div>
                        <div class="row no-gutters bg-white">
                            <div class="col-md-3 " style="border-right: 1px solid #e0e0e0">
                                <div class="card-body">
                                    <div class="filter-bar ui basic segment grid">
                                        <div class="ui form">
                                            <div class="inline field">
                                                <h6 class="heading-small text-muted mb-4">Account DashBoard</h6>

                                                <hr class="my-4 mb-0" />
                                                <div class="list-group list-group-flush">
                                                    <router-link  :to="{ name: 'account', params: { storeName: $route.params.storeName, accountName: $route.params.accountName}}" class="list-group-item list-group-item-action border-0"> Account Information</router-link>
                                                    <router-link  :to="{ name: 'address', params: { storeName: $route.params.storeName, accountName: $route.params.accountName}}" class="list-group-item list-group-item-action border-0 active"> Addresses</router-link>
                                                    <router-link :to="{ name: 'orders', params: { storeName: $route.params.storeName, accountName: $route.params.accountName}}" class="list-group-item list-group-item-action border-0">My Orders</router-link>
                                                  </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="card-header border-0">
                                    <div class="row align-items-center">
                                        <div class="col-md-3">
                                        </div>
                                        <div class="col-md-9 text-right">
                                            <a-button type="primary" class="btn float-right ml-1 btn-primary btn-sm" @click="addAddress"> + Add</a-button>
                                            <a-drawer title="" width="40%" placement="right" @close="onClose" :visible="visible" v-if="visible">
                                                <div>
                                                    <address-form @closeDrawer="closeDrawer" :AddressId="AddressId" v-on:refreshPage="refreshPage" :viewMode="viewMode" :action="action"> </address-form>
                                                </div>
                                            </a-drawer>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <a-card  size="small" style="width:100%;">
                                        <a-card-grid v-for="data in allData" class="col-6 p-3" style="cursor: pointer; max-height: 80vh; overflow: hidden;">
                                            <a-avatar class='float-right' >
                                            <a-popconfirm title="Are you sure？" ok-text="Yes" @confirm="DeleteAddress(data.id)" cancel-text="No">
                                                <a-icon type="delete" class="align-middle" />
                                            </a-popconfirm>
                                            </a-avatar>
                                            <a-avatar class='float-right' >
                                                <a-icon type="edit" @click.prevent="EditAddress(data.id)" class="align-middle" />
                                            </a-avatar>
                                            <p class="p-2 mb-0">
                                                {{data.street+' '+data.barangay_name+' '+data.city_name+' '+data.province_name+ ' '+ data.region_name}}
                                            </p>
                                        </a-card-grid>
                                    </a-card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
    </div>
</template>
<script>
import secureStorage from '../../controllers/secureStorage.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import AddressForm from '../../views/Online Store/AddressForm.vue'
import { mapState, mapActions } from 'vuex'
import axios from "axios"
var component_x;
export default {
    components: {
        HTTPRequest,
        AddressForm
    },
    computed: {
        ...mapState(['endPoint', 'parameters'])
    },
    data() {
        return {
            viewMode: false,
            visible:false,
            action:null,
            successMessage:null,
            AddressId:null,
            allData:[],
            CustomerAccountDetails:{}
        }
    },
    mounted: function(){
        var autoLogin = secureStorage.getItem("ecomLoggedIn")
        if(autoLogin == true){
            component_x = this
            this.salesChannelId = secureStorage.getItem("SalesChannelDetails").id
            this.storeDetails = secureStorage.getItem("SalesChannelDetails")
            this.$emit('showFooterAndHeader', event)
            this.$emit('hideSearchInput', event)
            if (secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus") != true){
                this.$router.push({ name: 'store',params:{ storeId:this.$route.params.storeId }})
            }else{
                this.CustomerAccountDetails = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin")
                this.getAllData()
            }
        }else{
            this.$router.push({ name: 'loading_screen', params: { returnUrl: 'customer_login', storeId:this.$route.params.storeId }})
        }
    },
    methods:{
        addAddress: function(){
            if (this.allData.length >= 5){
                component_x.successMessage = "You have reached the maximum limit of address."
            }else{
                this.action = "Create"
                this.showDrawer()
            }
        },
        showDrawer() {
            this.visible = true;
        },
        closeDrawer(){
            this.onClose()
        },
        refreshPage() {
            this.getAllData()
            this.successMessage = "Successful Operation"
            this.onClose()
        },
        onClose() {
            this.visible = false;
            this.AddressId = null;
        },
        getAllData: async function(){
            var response = await HTTPRequest.getRequest(this.endPoint + 'customer_addresses?email='+this.CustomerAccountDetails.email+'&account_id='+this.storeDetails.account_id,null)
            this.allData = response
        },
        DeleteAddress: async function(id){
            axios({
                method: 'delete',
                url: this.endPoint + 'customer_addresses/' + id+'?email='+this.CustomerAccountDetails.email+'&account_id='+this.storeDetails.account_id,
                headers: {
                    Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress"),
                    "Access-Control-Allow-Origin": "*"
                },
            })
            .then(function () {
                component_x.successMessage = "Successfully deleted record"
                component_x.getAllData()
            })
        },
        EditAddress(id){
            this.action = "Edit"
            this.showDrawer()
            this.AddressId = id
        }
    }
};
</script>
